import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from '@src/i18n/en/translation.json';
import caseStudiesEN from '@src/i18n/en/case-studies.json';
import translationES from '@src/i18n/es/translation.json';
import caseStudiesES from '@src/i18n/es/case-studies.json';

const resources = {
  en: {
    translation: translationEN,
    caseStudies: caseStudiesEN,
  },
  es: {
    translation: translationES,
    caseStudies: caseStudiesES,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: [
        'path',
        'htmlTag',
        'querystring',
        'cookie',
        'localStorage',
        'sessionStorage',
        'navigator',
        'subdomain',
      ],
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    resources,
    ns: ['translation', 'caseStudies'],
    supportedLngs: ['en', 'es'],
  });

export default i18n;
